import { formatDate } from "helpers/date";
import { vehicleOwnershipTypesEnum } from "helpers/enums";

const ownershipTypesWithBasisDocuments = new Set<string>([
    vehicleOwnershipTypesEnum.Rent,
    vehicleOwnershipTypesEnum.Leasing,
    vehicleOwnershipTypesEnum.FreeUse,
]);

const ownershipTypesWithoutBasisDocuments = new Set<string>([
    vehicleOwnershipTypesEnum.Own,
    vehicleOwnershipTypesEnum.SpousesJointProperty,
]);

type OwnershipBasisDocument = {
    date?: string | null;
    [key: string]: unknown;
};

type VehicleOwnershipData = {
    carrying?: number | string | null;
    volume?: number | string | null;
    ownershipBasisDocuments?: OwnershipBasisDocument[] | null;
    ownershipType?: string | null;
    [key: string]: unknown;
};

/** Check whether the selected ownership type requires contract documents. */
export function requiresOwnershipBasisDocuments(ownershipType?: string | null) {
    return !!ownershipType && ownershipTypesWithBasisDocuments.has(ownershipType);
}

/** Validate an optional vehicle capacity according to the backend apply rules. */
export function optionalVehicleCapacity(value?: string | number | null) {
    if (value === null || value === undefined || value === "") {
        return "";
    }

    const numericValue = Number(value);
    return Number.isFinite(numericValue) && numericValue > 0 ? "" : "Введите значение больше нуля";
}

const capacityForRequest = (value?: number | string | null) => {
    if (value === null || value === undefined || value === "") {
        return value;
    }
    return Number(value);
};

/** Convert editable capacity and DateOnly values to the backend request representation. */
export function prepareVehicleOwnershipData<T extends VehicleOwnershipData>(data: T): T {
    const ownershipBasisDocuments =
        data.ownershipType && ownershipTypesWithoutBasisDocuments.has(data.ownershipType)
            ? []
            : data.ownershipBasisDocuments;

    return {
        ...data,
        carrying: capacityForRequest(data.carrying),
        volume: capacityForRequest(data.volume),
        ownershipBasisDocuments: Array.isArray(ownershipBasisDocuments)
            ? ownershipBasisDocuments.map((document) => ({
                  ...document,
                  date: document.date ? formatDate(document.date) : document.date,
              }))
            : ownershipBasisDocuments,
    };
}
